module.exports = __webpack_public_path__ + "static/media/bottom_banner_4_2.ee73ccb9.png";